<template>
  <div v-if="chartData" ref="ffo1" id="ffo1"></div>
  <no-data-temporarily v-else class="flex-grow-1"></no-data-temporarily>
</template>
<script>
  import NoDataTemporarily from '@/components/utils/no-data-temporarily.vue';
  import TurnAskingMixin from '@/mixins/turn-ask';
  import { initResizeListener } from '@/utils/utils';
  import { getfuheyucefenxi } from '../../../api/statistical-analysis/statisticalanalysis';

  export default {
    data() {
      return {
        myChart: null,
        chartData: null,
        timeOut: null,
      };
    },
    mixins: [TurnAskingMixin],
    props: {
      select: String,
    },
    components: {
      NoDataTemporarily,
    },
    watch: {
      chartData() {
        this.initData();
      },
      select() {
        this.requestChartData();
      },
      skinType() {
        this.initData();
      },
    },
    created() {
      this.requestChartData();
    },
    computed: {
      skinType() {
        return this.$store.getters.skinType;
      },
    },
    methods: {
      requestChartData() {
        if (!this.select) {
          this.chartData = [];
          return;
        }
        clearTimeout(this.timeOut);
        getfuheyucefenxi({
          StationIdStr: this.select,
        })
          .then((res) => {
            this.chartData = res;
          })
          .catch(() => {
            this.chartData = null;
          }).then(() => {
            this.timeOut = this.turnAsking({
              routeName: this.routeName,
              nowRouteName: this.$route.name,
              func: this.requestChartData,
            }, 300000);
          });
      },
      // 初始化数据
      initData() {
        if (this.chartData === null) {
          return;
        }
        // 基于准备好的dom，初始化echarts实例
        this.myChart = this.$echarts.init(this.$refs.ffo1);
        // 绘制图表
        this.myChart.setOption({
          tooltip: {
            trigger: 'axis',
          },
          legend: {
            data: ['当前负荷', '预测负荷'],
            textStyle: {
              fontSize: '14',
              color: this.skinType ? 'white' : 'black',
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.chartData.xAxisData,
              axisLine: {
                color: this.skinType ? '#fff' : '#333',
              },
              axisLabel: {
                color: this.skinType ? '#fff' : '#333',
              },
            },
          ],
          yAxis: [
            {
              type: 'value',
              axisLine: {
                color: this.skinType ? '#fff' : '#333',
              },
              axisLabel: {
                color: this.skinType ? '#fff' : '#333',
              },
              splitLine: {
                lineStyle: {
                  type: 'dashed',
                  color: '#ccc',
                },
              },
            },
          ],
          series: [
            {
              name: '预测负荷',
              type: 'line',
              stack: '总量1',
              data: this.chartData.seriesData[1].Data,
            },
            {
              name: '当前负荷',
              type: 'line',
              stack: '总量2',
              data: this.chartData.seriesData[0].Data,
            },
          ],
        });
        initResizeListener(this.myChart, this.$refs.ffo1);
      },
    },
  };
</script>